import { LoadingSpinner } from '~/components/granular';

export function Loading() {
  return (
    <div className="p-4">
      <LoadingSpinner />
    </div>
  );
}
